import { render, staticRenderFns } from "./uiAdder.vue?vue&type=template&id=1064d163&scoped=true"
import script from "./uiAdder.vue?vue&type=script&lang=js"
export * from "./uiAdder.vue?vue&type=script&lang=js"
import style0 from "./uiAdder.vue?vue&type=style&index=0&id=1064d163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064d163",
  null
  
)

export default component.exports